module.exports = __webpack_public_path__ + "img/techtrologo_big.892765d1.png";